<template>
  <div class="social-icons">
    <a href="https://github.com/amacado" target="_blank"><i class="fab fa-github-square"></i></a>
    <a href="https://www.linkedin.com/in/clemensbastian/" target="_blank"><i class="fab fa-linkedin"></i></a>
    <a href="https://www.xing.com/profile/Clemens_Bastian2/" target="_blank"><i class="fab fa-xing-square"></i></a>
    <a href="https://twitter.com/amacado" target="_blank"><i class="fab fa-twitter-square"></i></a>
  </div>
</template>

<script>
  export default {
    name: "SocialIcons"
  }
</script>

<style scoped lang="scss">
  @import "../assets/styles/variables";
  div.social-icons {
    float: right;
    a {
      text-decoration: none;

      &:hover {
        i {
          color: $accent-color-shade-dark;
        }
    }

    i {
        font-size: 25px;
        margin-right: 0.5em;
        color: $accent-color-shade-light;
      }
    }
  }
</style>
